import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExceljsonUploadPopupComponent } from './exceljson-upload-popup.component';
import { MatIconModule } from "@angular/material/icon";



@NgModule({
  declarations: [ExceljsonUploadPopupComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule
]
})
export class ExceljsonUploadPopupModule { }
